<div class="offcanvas-container" [ngClass]="{ 'is-open': isPanelOpen }">
	<div class="offcanvas-overlay" (click)="closePanel()"></div>

	<div class="offcanvas-panel">
		<button class="panel-close-btn" (click)="closePanel()">×</button>
		<div class="panel-content">
			<iframe [src]="typeformUrl()" frameborder="0" allowfullscreen>
			</iframe>
		</div>
	</div>
</div>
